import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { LocalStorageService } from 'angular-2-local-storage';
import { Router } from '@angular/router';
import { CommonService } from '../common/common.service';
declare let $: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  @Output() toggleEvent = new EventEmitter();
  loginusername: string = "";
  @Output() sidebarEvent = new EventEmitter<string>();
  WelcomeQoute: string = "";
  JwtToken: string = "";
  Token: string = "";
  UserId: number = 0;
  Role: string = "";
  constructor(private common: CommonService, private LocalStorage: LocalStorageService,private router: Router) {
  }

  ngOnInit(): void {
    //this.GetClick();
    this.loginusername = this.LocalStorage.get("LoginUserName")
    this.Role = this.LocalStorage.get("UserRole");
    // this.createOnline$().subscribe(isOnline => console.log(isOnline));
  }
  logout() {
    this.common.logout(this.Token, this.UserId, "Manual");
  }



  GetClick() {
    (function ($) {
      'use strict';
      $(function () {
        $('[data-toggle="offcanvas"]').on("click", function () {
          $('.sidebar').toggleClass('toggled')
          alert('Classadded')
        });
      });
    })($);

    (function ($) {
      'use strict';
      $(function () {
        $('[data-toggle="minimize"]').on("click", function () {
          alert('2');
          $('body').toggleClass('sidebar-icon-only')
        });
      });
    })($);
    $(document).click(function () {
      $(".sidebar.active li a").click(function () {

        $('.sidebar').removeClass("toggled");
      });
    });
  }

  toggleSidebar() {
    this.sidebarEvent.emit();
  }
}
